"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const react_1 = require("react");
const lodash_1 = require("lodash");
const common_components_1 = require("@zapier/common-components");
const theme_1 = require("@zapier/theme");
const design_system_1 = require("@zapier/design-system");
const common_1 = require("../../common");
const ruleMatchChoices_1 = __importDefault(require("../../FilterField/ruleMatchChoices"));
const RuleMatchDropdown_1 = __importDefault(require("../../FilterField/RuleMatchDropdown"));
const RuleKeyDropdown_1 = __importDefault(require("../../FilterField/RuleKeyDropdown"));
const gridColumns = '3fr 260px 3fr 40px';
const gridGap = theme_1.Spacing.extraSmall;
const buttonColor = 'greyAlt';
const hasValueInput = (match) => lodash_1.isUndefined(match) || !['iexist', 'boolean'].includes(match);
function FilterRuleEditor(props) {
    const { choiceGroups, rule, onChange } = props;
    const onChangeKey = (key) => onChange(Object.assign(Object.assign({}, rule), { key }));
    const onChangeMatchChoice = (matchChoice) => {
        const { action, match } = matchChoice;
        return onChange(Object.assign(Object.assign({}, rule), { action,
            match }));
    };
    const [value, setValue] = react_1.useState(rule.value);
    const onChangeValue = (event) => setValue(event.target.value);
    const onBlurValue = () => onChange(Object.assign(Object.assign({}, rule), { value }));
    const onRemove = () => props.onRemove(rule.id);
    const initialMatchChoice = ruleMatchChoices_1.default.find(matchChoice => rule.match === matchChoice.match && rule.action === matchChoice.action);
    return (core_1.jsx(common_components_1.GridLayout, { columns: gridColumns, gap: gridGap },
        core_1.jsx(RuleKeyDropdown_1.default, { choiceGroups: choiceGroups, initialValue: rule.key, onChange: onChangeKey }),
        core_1.jsx(RuleMatchDropdown_1.default, { initialValue: initialMatchChoice, onChange: onChangeMatchChoice }),
        hasValueInput(rule.match) ? (core_1.jsx(common_1.TextInput, { ariaLabel: "Filter value", onBlur: onBlurValue, onChange: onChangeValue, placeholder: "Enter value\u2026", value: value })) : (core_1.jsx("div", null)),
        core_1.jsx(design_system_1.IconButton, { color: buttonColor, icon: "formX", label: "Remove this filter rule", onClick: onRemove, tooltipPosition: "north", type: "button" })));
}
exports.default = FilterRuleEditor;
